const Swap = (arr, firstIndex, secondIndex) =>
  ([arr[firstIndex], arr[secondIndex]] = [arr[secondIndex], arr[firstIndex]]);

export { Swap }; // eslint-disable-line import/prefer-default-export
